import routeNames from '@routes/routeNames';
import messages from './messages';
import { permission } from '../../../containers/admin/Secure/permission';

const BOOKING_SECONDARY_NAV = {
  routeMatches: [
    'Bookings',
    'BookingOverview',
    'BookingRoomNights',
    'BookingFolios',
    'BookingPaymentRecords',
    'BookingVirtualCreditCard',
    'BookingTickets',
    'BookingRateCards',
    'BookingCreate',
    'BookingCreateRoomAssignment'
  ],
  routes: [
    {
      route: 'Bookings',
      params: {},
      label: messages.linkBookings,
      icon: 'bookings',
      analyticID: 'bookings',
      reqPermission: permission.view.bookingManagement,
      routeMatches: [
        'Bookings',
        'BookingOverview',
        'BookingRoomNights',
        'BookingFolios',
        'BookingPaymentRecords',
        'BookingVirtualCreditCard',
        'BookingTickets',
        'BookingRateCards',
        'BookingCreate',
        'BookingCreateRoomAssignment'
      ]
    }
  ]
};

const CUSTOMER_SECONDARY_NAV = {
  routeMatches: [
    'Customers',
    'CustomerOverview',
    'CustomerMembers',
    'CustomerTrackingCodes',
    'MemberDetails',
    'CustomerPaymentIds',
    'CustomerRates',
    'CustomerPreferences',
    'CustomerFeatureSettings',
    'PendingRequests',
    'FeatureFlags',
    'FeatureFlagOverview'
  ],
  routes: [
    {
      route: 'Customers',
      params: {},
      label: messages.linkCustomers,
      icon: '',
      subMenu: [],
      analyticID: 'customers',
      reqPermission: permission.view.customerManagement,
      routeMatches: [
        'Customers',
        'CustomerOverview',
        'CustomerMembers',
        'CustomerTrackingCodes',
        'MemberDetails',
        'CustomerPaymentIds',
        'CustomerRates',
        'CustomerPreferences',
        'CustomerFeatureSettings'
      ]
    },
    {
      route: 'PendingRequests',
      params: {},
      label: messages.linkCustomerPendingRequests,
      icon: '',
      subMenu: [],
      analyticID: 'pending-requests',
      reqPermission: permission.view.customerRequests,
      routeMatches: ['PendingRequests']
    },
    {
      route: 'FeatureFlags',
      params: {},
      label: messages.linkFeatureFlags,
      icon: '',
      subMenu: [],
      analyticID: 'feature-flags',
      routeMatches: ['FeatureFlags', 'FeatureFlagOverview']
    }
  ]
};

const SUPPLIER_SECONDARY_NAV = {
  routeMatches: [
    'Suppliers',
    'SupplierOverview',
    'SupplierProperties',
    'RateCards',
    'RateCardsSelected',
    'ConnectionManagement',
    'RateEngineManagement',
    'SupplierPropertyAddRooms',
    routeNames.SUPPLIER_PROPERTY_OVERVIEW,
    routeNames.SUPPLIER_PROPERTY_ROOMS,
    routeNames.SUPPLIER_PROPERTY_CONNECTION,
    routeNames.SUPPLIER_PROPERTY_RATE_MARKUP_LOGS
  ],
  routes: [
    {
      route: 'Suppliers',
      params: {},
      label: messages.linkSuppliers,
      icon: '',
      subMenu: [],
      analyticID: 'suppliers',
      reqPermission: permission.view.supplierManagement,
      routeMatches: [
        'Suppliers',
        'SupplierOverview',
        'SupplierProperties',
        'SupplierPropertyAddRooms',
        routeNames.SUPPLIER_PROPERTY_OVERVIEW,
        routeNames.SUPPLIER_PROPERTY_ROOMS,
        routeNames.SUPPLIER_PROPERTY_CONNECTION,
        routeNames.SUPPLIER_PROPERTY_RATE_MARKUP_LOGS
      ]
    },
    {
      route: 'RateCards',
      params: {},
      label: messages.linkRateCards,
      icon: '',
      subMenu: [],
      analyticID: 'rate-cards',
      reqPermission: permission.view.rateCard,
      routeMatches: ['RateCards']
    },
    {
      route: 'ConnectionManagement',
      params: {},
      label: messages.linkConnectionManagement,
      icon: '',
      subMenu: [],
      analyticID: 'connection-management',
      routeMatches: ['ConnectionManagement']
    },
    {
      route: 'RateEngineManagement',
      params: {},
      label: messages.linkRateEngineManagement,
      icon: '',
      subMenu: [],
      routeMatches: ['RateEngineManagement'],
      analyticID: 'rate-engine-management',
      reqPermission: permission.view.productTeam
    }
  ]
};

const USER_SECONDARY_NAV = {
  routeMatches: ['Users', 'UserOverview', 'Roles', 'Permissions', 'CreatePermission'],
  routes: [
    {
      route: 'Users',
      params: {},
      label: messages.linkUsers,
      icon: '',
      subMenu: [],
      analyticID: 'users',
      routeMatches: ['Users', 'UserOverview']
    },
    {
      route: 'Roles',
      params: {},
      label: messages.linkRoles,
      icon: '',
      subMenu: [],
      analyticID: 'roles',
      routeMatches: ['Roles']
    },
    {
      route: 'Permissions',
      params: {},
      label: messages.linkPermissions,
      icon: '',
      subMenu: [],
      analyticID: 'permissions',
      routeMatches: ['Permissions', 'CreatePermission']
    }
  ]
};

const ACCOUNTING_SECONDARY_NAV = {
  routeMatches: [
    'COGS',
    'FoliosByBooking',
    'FolioMissing',
    'FolioOverview',
    'Reconciliation',
    'Viewer',
    'Chargesheets',
    'Chargesheet',
    'ChargesheetPreview',
    'ChargesheetFolios',
    'CreateChargesheet',
    'Invoices',
    'InvoiceDetails',
    'DraftInvoiceDetails',
    'VendorBills',
    'VendorBillDetails',
    'DraftVendorBillDetails',
    'TaxTemplates',
    'TaxesAndFees'
  ],
  routes: [
    {
      route: 'COGS',
      params: {},
      label: messages.linkCOGS,
      icon: '',
      subMenu: [],
      analyticID: 'cogs',
      reqPermission: permission.view.folio,
      routeMatches: ['COGS', 'FolioOverview', 'FoliosByBooking', 'FolioMissing']
    },
    {
      route: 'Reconciliation',
      params: {},
      label: messages.linkReconciliation,
      icon: '',
      subMenu: [],
      analyticID: 'reconciliation',
      reqPermission: permission.view.reconciliation,
      routeMatches: ['Reconciliation', 'Viewer']
    },
    {
      route: 'Chargesheets',
      params: {},
      label: messages.linkChargesheets,
      icon: '',
      subMenu: [],
      analyticID: 'chargesheets',
      reqPermission: permission.view.payment,
      routeMatches: ['Chargesheets', 'Chargesheet', 'CreateChargesheet', 'ChargesheetPreview', 'ChargesheetFolios']
    },
    {
      route: 'Invoices',
      label: messages.linkInvoices,
      analyticID: 'invoices',
      reqPermission: permission.view.invoices,
      routeMatches: ['Invoices', 'InvoiceDetails', 'DraftInvoiceDetails']
    },
    {
      route: 'VendorBills',
      label: messages.linkVendorBills,
      analyticID: 'vendor-bills',
      reqPermission: permission.view.invoices,
      routeMatches: ['VendorBills', 'VendorBillDetails', 'DraftVendorBillDetails']
    },
    {
      route: 'TaxTemplates',
      params: {},
      label: messages.linkTaxesAndFees,
      icon: '',
      subMenu: [],
      analyticID: 'tax-templates',
      reqPermission: permission.view.taxTemplate,
      routeMatches: ['TaxTemplates', 'TaxesAndFees']
    }
  ]
};

const VCC_SECONDARY_NAV = {
  routeMatches: ['AccountManagement', 'CardManagement', 'Approvals', 'ApprovalSingle'],
  routes: [
    {
      route: 'AccountManagement',
      params: {},
      label: messages.linkAccountManagement,
      icon: '',
      subMenu: [],
      analyticID: 'account-management',
      routeMatches: ['AccountManagement']
    },
    {
      route: 'CardManagement',
      params: {},
      label: messages.linkCardManagement,
      icon: '',
      subMenu: [],
      analyticID: 'card-management',
      routeMatches: ['CardManagement']
    },
    {
      route: 'Approvals',
      params: {},
      label: messages.linkApprovals,
      icon: 'approvals',
      analyticID: 'booking-approvals',
      subMenu: [],
      routeMatches: ['Approvals', 'ApprovalSingle']
    }
  ]
};

const TICKET_SECONDARY_NAV = {
  routeMatches: ['Tickets', 'TicketOverview'],
  routes: [
    {
      route: 'Tickets',
      params: {},
      label: messages.linkTickets,
      icon: 'tickets',
      subMenu: [],
      analyticID: 'tickets',
      routeMatches: ['Tickets', 'TicketOverview']
    }
  ]
};

export const SECONDARY_NAV_LINKS = [
  BOOKING_SECONDARY_NAV,
  CUSTOMER_SECONDARY_NAV,
  SUPPLIER_SECONDARY_NAV,
  USER_SECONDARY_NAV,
  ACCOUNTING_SECONDARY_NAV,
  VCC_SECONDARY_NAV,
  TICKET_SECONDARY_NAV
];
